<template>
  <div>
      <div class="popup-overlay" v-if="showPopup" @click.self="closePopup">
          <div class="popup-content">
              <div style="display: flex; align-items: center; margin-bottom: 10px;">
                  <h6>{{ $resourceString['product.Detail.Heading.DyelotInfo'] }}</h6>
                  <button class="popup-close-button" @click="closePopup">
                      <span class="png-icon png-icon-icons-symbols--k-txtclose"></span>
                  </button>
              </div>
              <div class="dyelot-container">
                  <div class="dyelot-header">
                      <p><strong>{{ $resourceString['product.Detail.Title.Dyelot'] }}</strong></p>
                  </div>
                  <div class="qty-header">
                      <p><strong>{{ $resourceString['product.Detail.Label.AvailableQty'] }}</strong></p>
                  </div>
              </div>
              <div class="dyelot-container" v-for="dyelotObject in dyelotObjects" :key="dyelotObject.dyeLot">
                  <div class="dyelot-info">
                      <p>{{ dyelotObject.dyeLot }}</p>
                  </div>
                  <div class="qty-info">
                      <p>{{ dyelotObject.availQty }} {{ dyelotObject.uom }}</p>
                  </div>
              </div>
              <div>
                  <p class="text-success dye-lot-info-notice">
                    {{ $resourceString['product.Detail.Label.DyelotInfo'] }}
                  </p>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  props: {
      showPopup: Boolean,
      dyelotObjects: Array,
  },
  watch: {
      showPopup(newVal) {
          if (newVal) {
              this.disableBodyScroll();
          } else {
              this.enableBodyScroll();
          }
      },
  },
  methods: {
      closePopup() {
          this.$emit('close');
      },
      disableBodyScroll() {
          document.body.style.overflow = 'hidden';
      },
      enableBodyScroll() {
          document.body.style.overflow = '';
      },
  },
  mounted() {
      if (this.showPopup) {
          this.disableBodyScroll();
      }
  },
  beforeDestroy() {
      this.enableBodyScroll();
  },
};
</script>
